import { createContext, useContext } from 'react';

export interface OpenLoginOptions {
  /** Where a login that leaves the site should come back to; defaults to the current page. */
  returnTo?: string;
  /** Closed without logging in (e.g. reset the caller's own "login requested" state). */
  onDismiss?: () => void;
  /** Logged in: resume what the visitor was doing. */
  onLoggedIn?: () => void;
}

interface LoginPromptValue {
  openLogin: (options?: OpenLoginOptions) => void;
}

export const LoginPromptContext = createContext<LoginPromptValue>({
  openLogin: () => undefined,
});

/** Ask for login from anywhere under LoginPromptProvider. */
export const useLoginPrompt = (): LoginPromptValue =>
  useContext(LoginPromptContext);
